import { Fragment, useState, useEffect } from "react";
import about from "../img/pl.jpg";

const Preventing = () => {
  const [isMobile, setIsMobile] = useState(false);

  //choose the screen size
  const handleResize = () => {
    if (window.innerWidth < 990) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };
  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = "";
  };
  useEffect(() => {
    window.scrollTo(0, 0);

    if (window.performance) {
      handleResize();

      if (performance.navigation.type == 1) {
        //     window.addEventListener("beforeunload", alertUser);
        return () => {
          window.addEventListener("resize", handleResize);

          //         window.removeEventListener("beforeunload", alertUser);
        };
      }
    }
  }, []);
  return (
    <Fragment>
      <div
        style={{
          position: "relative",
          top: !isMobile ? "100px" : "0px",
        }}
        class="container-fluid bg-primary py-5  mb-5"
        className="pfb"
      >
        <div class="row py-3">
          <div class="col-12 text-center">
            <h1
              style={{
                marginTop: "90px",
              }}
              class="display-3 text-white animated zoomIn"
            >
              {" "}
              Preventing Falls{" "}
            </h1>
            <a href="/" class="h4 text-white">
              Home
            </a>
            <i class="far fa-circle text-white px-2"></i>
            <a href="" class="h4 text-white">
              Preventing Falls{" "}
            </a>
          </div>
        </div>
      </div>

      <div
        style={{
          position: "relative",
          top: !isMobile ? "100px" : "0px",
          marginBottom: !isMobile ? "100px" : "50px",
        }}
        className="container-fluid py-5 wow fadeInUp"
        data-wow-delay="0.1s"
      >
        {/* container1 */}

        <div className="container">
          <div className="row g-5">
            <div className="col-lg-7">
              <div className="section-title mb-4">
                <h5 className="position-relative d-inline-block text-primary text-uppercase">
                  Preventing Falls{" "}
                </h5>
                <h1 className="display-5 mb-0">
                  Staying Safe at Home: Preventing Falls
                </h1>
              </div>

              <div className="mb-4">
                <p>
                  Falls are one of the most common reasons older and disabled
                  people lose confidence, get hurt or need to go into hospital.
                  The good news is that many falls can be prevented. Small
                  changes at home, and a little help from the right people, can
                  make a big difference.
                </p>
                <h4 className="mt-4">Why falls happen</h4>
                <p>Falls are more likely when someone has:</p>
                <ul>
                  <li>Weak muscles, stiff joints or problems with balance</li>
                  <li>Poor eyesight, or glasses that need updating</li>
                  <li>
                    Medicines that cause dizziness or drowsiness, or several
                    medicines taken together
                  </li>
                  <li>Low blood pressure when standing up</li>
                  <li>Needing the toilet urgently, especially at night</li>
                  <li>
                    Trip hazards at home, such as loose rugs, trailing cables,
                    clutter or poor lighting
                  </li>
                </ul>
                <h4 className="mt-4">Simple ways to stay safe at home</h4>
                <ul>
                  <li>Keep floors and stairs clear, and remove or secure loose rugs</li>
                  <li>
                    Use good lighting, including night lights between the
                    bedroom and bathroom
                  </li>
                  <li>
                    Wear well-fitting shoes or slippers with a good grip, not
                    loose or backless ones
                  </li>
                  <li>
                    Use grab rails and handrails, and any walking aids you have
                    been given
                  </li>
                  <li>Stand up slowly, especially after sitting or lying down</li>
                  <li>
                    Keep everyday items within easy reach so you don't need to
                    climb or stretch
                  </li>
                  <li>Drink enough fluids and eat regular meals</li>
                  <li>Stay active: gentle exercise helps strength and balance</li>
                </ul>
                <h4 className="mt-4">Check-ups that help</h4>
                <ul>
                  <li>Have your eyes tested regularly</li>
                  <li>
                    Ask your GP or pharmacist to review your medicines,
                    especially if you feel dizzy
                  </li>
                  <li>
                    Tell your GP about any falls, even if you weren't hurt. They
                    can arrange a falls assessment or strength and balance
                    classes
                  </li>
                </ul>
                <h4 className="mt-4">If someone falls</h4>
                <p>
                  Stay calm. If they are hurt, can't get up, or have hit their
                  head, call 999. If they are not hurt, help them get up slowly,
                  using a sturdy chair for support. Always let their GP know
                  about the fall.
                </p>
                <h4 className="mt-4">More information</h4>
                <ul>
                  <li>
                    <a href="https://www.nhs.uk/conditions/falls/" target="_blank" rel="noreferrer">
                      NHS: Falls
                    </a>
                  </li>
                  <li>
                    <a href="https://www.ageuk.org.uk/information-advice/health-wellbeing/exercise/falls-prevention/" target="_blank" rel="noreferrer">
                      Age UK: Preventing falls
                    </a>
                  </li>
                </ul>
                <p className="mt-4">
                  Worried about a loved one? Call us on{" "}
                  <a href="tel:+441268988500">01268 988500</a> to talk about how
                  our care and support can help them stay safe at home.
                </p>
              </div>
            </div>
            <div className="col-lg-5" style={{ minHeight: "500px" }}>
              <div className="position-relative h-100">
                <img
                  className="position-absolute w-100 h-100 rounded wow zoomIn"
                  data-wow-delay="0.9s"
                  src={about}
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Preventing;
